import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography, useTheme } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import "./style.css";
import CustomButton from 'components/Fileds/CustomButton';
import CustomTypography from 'components/Fileds/CustomTypography';

const ConfirmationDialog = ({ open, handleClose, handleConfirm, btnText, infoText, isLoading, action }) => {
  const theme = useTheme();
  return (
    <>
      <Dialog
        open={open}
        onClose={!isLoading ? handleClose : undefined}
        className='confirm-modal-container'
        PaperProps={{
          sx: {
            width: "448px",
            borderRadius: "8px",
            background: "white",

          },
        }}
      >
        <DialogTitle className='confirm-modal-title' sx={{ color: 'primary.main', textTransform: 'capitalize' }}>
          Confirm {action}
          <IconButton
            onClick={isLoading ? undefined : handleClose}
            className='close-icon-modal'
            sx={{
              color: (theme) => theme.palette.grey[500],
              cursor: isLoading ? 'not-allowed' : 'pointer',
              pointerEvents: isLoading ? 'none' : 'auto',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            padding: "16px",
          }}
        >
          <CustomTypography
            variant={"body1"}
            label={infoText}
            sx={{ color: theme.palette.typographyLabel.main }}
          />
        </DialogContent>
        <DialogActions
          className='dialog-actions-container'>
          <CustomButton
            onClick={isLoading ? undefined : handleClose}
            sx={{
              backgroundColor: 'transparent',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              pointerEvents: isLoading ? 'none' : 'auto',
            }}
            variant="outlined"
            className='close-btn'
          >
            Close
          </CustomButton>
          <CustomButton
            onClick={handleConfirm}
            loading={isLoading}
            variant="contained"
            className='confirm-btn'
          // sx={{backgroundColor:'black',color:'white'}}
          >
            {btnText}
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationDialog;
